/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { RouteList } from './Constant';
import {
  SignIn,
  Home,
  VerifyOtp,
  Complaints,
  Customers,
  Users,
  NotFound,
  CreatePassword,
  ForgotPassword,
  TokenVaildError,
  CustomerDetails,
  EmployerDetails,
  Admins,
  Employers,
  EmployessDetails,
  OrgHome,
  EmployeeView,
  ChartDetails,
  Uploads,
  Chats,
  CustomerChat,
  CustomerComplaints,
  Requests,
  UserRequestDetails,
  // Transfers,
  // TransferDetails,
  FundManagement,
  UserAudit,
  EmployeeAudit,
  ComplaintAudit,
  ChatAudit,
  TransactionAudit,
  Orders,
  UserPlanContribution,
  UserWiseContribution,
  EmployeeContributionDetails,
  UploadDetails,
  OTPVerification,
  ReplacingPolicy,
  ReplacingPolicyUserDetails,
  DailyReports,
  Reports,
  Configuration,
  UnitsReallocation
} from '../pages';
import jwt_decode from 'jwt-decode';
import { type ComponentType } from 'react';

import EmployeeDetails from 'pages/Employer/EmployeeDetails';
import Employees from 'pages/Employer/Employees';
import Contributions from 'pages/Contributions';
import FeeCalculation from 'pages/FeeCalculation';
import { roles } from 'constants/constantText';
import DailyFundPrice from 'pages/DailyFundPrice';

interface IRouteListProps {
  name?: string;
  path?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any> | null;
}
export const getRole = (): string | null => {
  const credentials = JSON.parse(sessionStorage.getItem('credentials') as string);
  if (credentials?.access_token) {
    const { role }: { role: string } = jwt_decode(credentials.access_token);

    if (role?.length > 0) {
      return role;
    }
    return null;
  }
  return null;
};
export const getPrivateRoutes = (): IRouteListProps[] => {
  let routes: IRouteListProps[] = [];
  const roleName = getRole();
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (
    roleName?.includes(roles.MMEmployeeRole) ||
    roleName?.includes(roles.CeoRole)
  ) {
    routes = [
      {
        name: 'Home',
        path: RouteList.Home,
        Component: Home,
      },
      {
        name: 'Employers',
        path: RouteList.Employers,
        Component: Employers,
      },
      {
        name: 'Customers',
        path: RouteList.Customers,
        Component: Customers,
      },
      {
        name: 'Contributions',
        path: RouteList.Contributions,
        Component: Contributions,
      },
      {
        name: 'Orders',
        path: RouteList.Orders,
        Component: Orders,
      },
      {
        name: 'Daily Reports',
        path: RouteList.DailyReports,
        Component: DailyReports,
      },
      {
        name: 'Fund Management',
        path: RouteList.FundManagement,
        Component: FundManagement,
      },
      {
        name: 'Onboarding',
        path: RouteList.Onboarding,
        Component: ReplacingPolicy,
      },

      {
        name: 'Requests',
        path: RouteList.Requests,
        Component: Requests,
      },
      {
        name: 'Complaints',
        path: RouteList.Complaints,
        Component: Complaints,
      },
      {
        name: 'Chats',
        path: RouteList.Chats,
        Component: Chats,
      },
      {
        name: 'Uploads',
        path: RouteList.Uploads,
        Component: Uploads,
      },
      {
        name: 'UserPlanContribution',
        path: RouteList.UserPlanContribution,
        Component: UserPlanContribution,
      },
      {
        name: 'UserWiseContribution',
        path: RouteList.UserWiseContribution,
        Component: UserWiseContribution,
      },
      {
        name: 'Charge Calculation',
        path: RouteList.FeeCalculation,
        Component: FeeCalculation,
      },
      {
        name: 'Users',
        path: RouteList.Users,
        Component: Users,
      },
      {
        name: 'Report',
        path: RouteList.Reports,
        Component: Reports,
      },
      {
        name: 'Daily Fund Price',
        path: RouteList.DailyFundPrice,
        Component: DailyFundPrice,
      },
      {
        name: 'Units Reallocation',
        path: RouteList.UnitsReallocation,
        Component: UnitsReallocation,
      },
      {
        name: 'Configuration',
        path: RouteList.Configuration,
        Component: Configuration,
      },
      {
        name: 'Logout',
        path: RouteList.Logout,
        Component: Home,
      },
      {
        path: RouteList.ChartDetails,
        Component: ChartDetails,
      },
      {
        path: RouteList.CustomerChat,
        Component: CustomerChat,
      },
      {
        path: RouteList.CustomerComplaints,
        Component: CustomerComplaints,
      },
      {
        path: RouteList.UserRequestDetails,
        Component: UserRequestDetails,
      },

      // {
      //   path: RouteList.TransferDetails,
      //   Component: TransferDetails,
      // },
    ];
  } else if (roleName?.includes(roles.OrganizationAdminRole)) {
    routes = [
      {
        name: 'Home',
        path: RouteList.OrgHome,
        Component: OrgHome,
      },
      {
        name: 'Employees',
        path: RouteList.Employees,
        Component: Employees,
      },
      {
        name: 'Admins',
        path: RouteList.Admins,
        Component: Admins,
      },
      {
        name: 'Contributions',
        path: RouteList.Contributions,
        Component: Contributions,
      },
      {
        name: 'Logout',
        path: RouteList.Logout,
        Component: Home,
      },
      {
        path: RouteList.ChartDetails,
        Component: ChartDetails,
      },
    ];
  } else if (roleName?.includes(roles.AuditorRole)) {
    routes = [
      // Super admin routes
      {
        name: 'Home',
        path: RouteList.OrgHome,
        Component: OrgHome,
      },
      {
        name: 'User Audit',
        path: RouteList.UserAudit,
        Component: UserAudit,
      },
      {
        name: 'Employee Audit',
        path: RouteList.EmployeeAudit,
        Component: EmployeeAudit,
      },
      {
        name: 'Complaint Audit',
        path: RouteList.ComplaintAudit,
        Component: ComplaintAudit,
      },
      {
        name: 'Chat Audit',
        path: RouteList.ChatAudit,
        Component: ChatAudit,
      },
      {
        name: 'Transaction Audit',
        path: RouteList.TransactionAudit,
        Component: TransactionAudit,
      },
      {
        name: 'Logout',
        path: RouteList.Logout,
        Component: Home,
      },
    ];
  } else {
    routes = [
      {
        name: 'Home',
        path: RouteList.Home,
        Component: Home,
      },
      {
        name: 'Complaints',
        path: RouteList.Complaints,
        Component: Complaints,
      },
      {
        name: 'Customers',
        path: RouteList.Customers,
        Component: Customers,
      },
      {
        name: 'Users',
        path: RouteList.Users,
        Component: Users,
      },
      {
        name: 'Logout',
        path: RouteList.Logout,
        Component: Home,
      },
    ];
  }
  routes = [
    ...routes,
    ...[
      {
        path: RouteList.CustomerDetails,
        Component: CustomerDetails,
      },
      {
        path: RouteList.OnboardingByUser,
        Component: ReplacingPolicyUserDetails,
      },
      {
        path: RouteList.EmployerDetails,
        Component: EmployerDetails,
      },
      {
        path: RouteList.Employees,
        Component: Employees,
      },
      {
        path: RouteList.EmployessDetails,
        Component: EmployessDetails,
      },
      {
        path: RouteList.EmployeeDetails,
        Component: EmployeeDetails,
      },
      {
        path: RouteList.EmployeeView,
        Component: EmployeeView,
      },
      {
        path: RouteList.EmployeeContributionDetails,
        Component: EmployeeContributionDetails,
      },
      {
        path: RouteList.UploadDetails,
        Component: UploadDetails,
      },
    ],
  ];
  return routes;
};

export let privateRoutes: IRouteListProps[] = getPrivateRoutes();
export const setPrivateRoutes = (): void => {
  privateRoutes = getPrivateRoutes();
};
export const authRoutes: IRouteListProps[] = [
  {
    Component: SignIn,
    path: RouteList.SignIn,
  },
  {
    Component: VerifyOtp,
    path: RouteList.VerifyOtp,
  },
  {
    Component: CreatePassword,
    path: RouteList.CreatePassword,
  },
  {
    Component: ForgotPassword,
    path: RouteList.ForgotPassword,
  },
  {
    Component: TokenVaildError,
    path: RouteList.TokenError,
  },
];

export const publicRoutes = [
  {
    Component: NotFound,
    path: RouteList.NotFound,
  },

  {
    Component: OTPVerification,
    path: RouteList.OtpVerification,
  },
];
